/**
 * 农历转换工具
 * 使用 lunar-javascript 库进行准确的农历转换
 */

import { Lunar } from 'lunar-javascript';

export interface LunarDate {
  year: number;
  month: number;
  day: number;
  isLeap: boolean;
  monthName: string;
  dayName: string;
  fullName: string;
}

/**
 * 将公历日期转换为农历日期
 */
export function solarToLunar(date: Date): LunarDate {
  try {
    const lunar = Lunar.fromDate(date);
    const lunarYear = lunar.getYear();
    const lunarMonth = lunar.getMonth();
    const lunarDay = lunar.getDay();
    // 闰月判断：月份为负数表示闰月
    const isLeap = lunarMonth < 0;
    // 获取实际月份（如果是闰月，取绝对值）
    const actualMonth = Math.abs(lunarMonth);
    
    // 获取农历月份名称
    const monthName = lunar.getMonthInChinese();
    
    // 获取农历日期名称
    const dayName = lunar.getDayInChinese();
    
    // 构建完整名称
    const fullName = `${monthName}${dayName}`;
    
    return {
      year: lunarYear,
      month: actualMonth,
      day: lunarDay,
      isLeap,
      monthName,
      dayName,
      fullName,
    };
  } catch (error) {
    console.error('农历转换失败:', error);
    // 如果转换失败，返回简化版本
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return {
      year,
      month,
      day,
      isLeap: false,
      monthName: `${month}月`,
      dayName: `${day}日`,
      fullName: `${month}月${day}日`,
    };
  }
}

/**
 * 获取农历日期的简短显示（用于日历）
 */
export function getLunarDisplay(date: Date): string {
  try {
    const lunar = Lunar.fromDate(date);
    return lunar.getDayInChinese();
  } catch (error) {
    console.error('获取农历显示失败:', error);
    return '';
  }
}
